module.exports = __webpack_public_path__ + "img/DSC_2708-xl.635c5245.png";